<template>
  <div :class="extraButtons ? 'bigger-card remove-cursor' :''" class="data-card" @click="handleClickEvent">
    <div class="data-card-header">
      <h1 :class="smallText ? 'text-smoll-content' : ''" >{{title}}</h1>
    </div>
    <div :class="extraButtons ? 'bigger-card-content' :''" class="data-card-content">
      <div v-if="avgTime > 0 || myTime > 0" class="data-label">
        <p class="data-my-avg" >{{highestAvg ? 'Highest' : 'Student Avg.'}}</p>
        <p class="data-avg">Avg.</p>
      </div>
      <double-slider v-if="avgTime > 0 || myTime > 0" :width="250" :avgTime="avgTime" :myTime="myTime" />
      <h6 v-if="!radialData.every(item => item === 0)">Score:</h6>
      <custom-radial-chart v-if="!radialData.every(item => item === 0)" :displayScore="false" class="radial-move" :height="extraButtons ? '150' : '190'" width="200" :series="radialData" />
      <h3 v-if="avgTime == 0 && myTime == 0 && radialData.every(item => item === 0)">No data</h3>
      <div v-if="extraButtons" class="data-label">
        <vs-button @click.prevent.stop="handleStudentClick" class="btn-classroom-select" >Students</vs-button>
        <vs-button @click.prevent.stop="handleModuleClick" class="btn-classroom-select"  >Modules</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomRadialChart from './CustomRadialChart.vue'
import DoubleSlider from './DoubleSlider.vue'

export default {
  data(){
    return{
    }
  },
  components:{
    CustomRadialChart,
    DoubleSlider
  },
  props:{
    title:{
      typeof:String,
      required:true
    },
    myTime:{
      typeof:Number,
      required:true
    },
    avgTime:{
      typeof:Number,
      required:true
    },
    radialData:{
      typeof:Array,
      required:true
    },
    type: {
      type: String,
      required: true
    },
    smallText:{
      type:Boolean,
      required:false,
    },
    extraButtons:{
      type:Boolean,
      required:false,
    },
    highestAvg:{
      type: Boolean,
      required: false
    }
  },
  watch: {
    myTime: function(val) {
    }
  },
  methods:{
    handleClickEvent() {
      this.$emit('handleClick');
    },
    handleStudentClick(){
      this.$emit('handleStudentClick');
    },
    handleModuleClick(){
      this.$emit('handleModuleClick');
    }
  },
  mounted(){
  },
  
}
</script>



<style scoped lang="scss">

.bigger-card{
  height: 310px !important;
}

.bigger-card-content{
  height: 250px !important;
}

.data-card{
  box-shadow: 3px 3px 6px 3px rgba(0, 0, 0, 0.2) !important;
  transition: transform .15s ease-in, box-shadow .2s ease-in;
  border-radius: 15px;
  width: 300px;
  height: 290px;
  cursor: pointer;
  &:hover {
    transform: scale(1.035);
    box-shadow: 0px 5px 6px 3px rgba(0, 0, 0, 0.3) !important;
  }
  .data-card-header{
    padding: 5px;
    height: 60px;
    border-radius: 15px 15px 0px 0px;
    //background-color: rgba(var(--vs-primary),100);
    background: linear-gradient(to right, rgba(var(--vs-primary), 1), rgba(var(--vs-secondary), 1));
    display: flex;
    h1{
      font-size: 24px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;
    }
  }
  .data-card-content{
    padding: 10px 10px 20px 10px;
    position: relative;
    background-color: #101738;
    height: 230px;
    border-radius: 0px 0px 15px 15px ;
    h6{
      position: absolute;
    }
    .h6-lower{
      top: 42px;
    }
  }
  .data-label{
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    .data-my-avg::before{
      background-color: rgba(var(--vs-primary),100)
    }
    .data-avg::before{
      background-color: white;
    }
    p::before{
      content: '';
      border-radius: 50%;
      height: 10px;
      width: 10px;
      margin-right: 5px;
      display: inline-block;
    }
  }
  .radial-move{
    margin-top: -20px;
    justify-content: center;
  }
  .text-smoll-content{
    font-size: 15px !important;
  }
  .btn-classroom-select{
    width: 125px;
    height: 35px;
    padding:  unset !important;
  }
}
.remove-cursor{
    cursor: default !important;
  }
</style>
